import { useState } from "react";
import { toFormattedInteger } from "src/utils";
import DeleteFinancialAccountModal from "../DeleteFinancialAccountModal";
import type { DomainAssetType } from "@porchpass/api-client";
import type { FinancialAccountFormData } from "src/types/financial-accounts";
import { BankIcon, FormTableSummaryCard } from "@porchpass/ui";

type FinancialAccountItemProps = {
  financialAccount: FinancialAccountFormData;
  index?: number;
  editHandler: () => void;
  closeHandler: () => void;
  deleteHandler: () => void;
};

const toAccountType: Record<DomainAssetType, string> = {
  CHECKING: "Checking Account",
  SAVINGS: "Savings Account",
  BONDS: "Bonds",
  CASH_VALUE_OF_LIFE_INSURANCE: "Cash Value of Life Insurance",
  CERTIFICATE_OF_DEPOSIT: "Certificate of Deposit",
  MUTUAL_FUNDS: "Mutual Funds",
  OTHER_REAL_ESTATE: "Other Real Estate",
  RETIREMENT: "Retirement",
  STOCKS: "Stocks",
  TRUST_ACCOUNT: "Trust Account",
  OTHER: "Other",
};

export default ({
  financialAccount,
  index = 0,
  editHandler,
  closeHandler,
  deleteHandler,
}: FinancialAccountItemProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <FormTableSummaryCard
        index={index}
        title={financialAccount.institution_name || "Account Unknown"}
        isUnknown={!financialAccount.institution_name?.trim()}
        icon={
          <BankIcon variant="bulk-rounded" size={16} className="text-primary" />
        }
        iconTone="primary"
        subtitles={[toAccountType[financialAccount.account_type ?? "OTHER"]]}
        amount={{
          value: `$${toFormattedInteger(financialAccount.balance_amount)}`,
        }}
        onClick={editHandler}
        onEdit={editHandler}
        onDelete={() => setIsDeleteModalOpen(true)}
      />
      <DeleteFinancialAccountModal
        isOpen={isDeleteModalOpen}
        financialAccountId={financialAccount.id ?? ""}
        closeHandler={() => {
          setIsDeleteModalOpen(false);
          closeHandler();
        }}
        deleteHandler={() => {
          setIsDeleteModalOpen(false);
          deleteHandler();
        }}
      />
    </>
  );
};
